import { FieldError } from '../shadcn/field';

export const LabelError = ({ children }: React.PropsWithChildren) => {
  const errorMessage = children as string;

  return (
    <FieldError data-elements={errorMessage} className="text-body-large text-danger-default">
      {children}
    </FieldError>
  );
};
